// extracted by mini-css-extract-plugin
export var downArrow = "_al-0";
export var label = "_al-1";
export var treatmentCard = "_al-3";
export var upArrow = "_al-2";